export * from './post-archivieren.component';
export * from './post-archivieren.component.module';